import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { decryptToken } from "../utils/getToken";

const CorsOriginModal = ({ isOpen, setIsOpen, editRow, fetchRows }) => {
  const urlmain = API_BASE_URL;
  const token = decryptToken("accessToken") || "";
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    origin: "",
    label: "",
  });

  useEffect(() => {
    if (editRow) {
      setForm({
        origin: editRow.origin || "",
        label: editRow.label || "",
      });
    } else {
      setForm({ origin: "", label: "" });
    }
  }, [editRow, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const isEdit = Boolean(editRow?.id);
      const response = await fetch(
        isEdit ? `${urlmain}/cors-origins/${editRow.id}` : `${urlmain}/cors-origins`,
        {
          method: isEdit ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(form),
        }
      );
      const res = await response.json();

      if (response.ok && !res.isError) {
        toast.success(res.message);
        setIsOpen(false);
        fetchRows();
      } else {
        toast.error(res.message || "Save failed");
      }
    } catch (error) {
      toast.error(error.message || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">
          {editRow ? "Edit Access URL" : "Add Access URL"}
        </h2>
        <form className="oms-modal-form" onSubmit={handleSubmit}>
          <div className="oms-form-group">
            <label htmlFor="origin" className="oms-form-label">
              Website / Origin URL
            </label>
            <input
              type="text"
              name="origin"
              id="origin"
              value={form.origin}
              onChange={handleChange}
              placeholder="https://example.com"
              required
            />
          </div>
          <div className="oms-form-group">
            <label htmlFor="label" className="oms-form-label">
              Label (optional)
            </label>
            <input
              type="text"
              name="label"
              id="label"
              value={form.label}
              onChange={handleChange}
              placeholder="Client storefront"
            />
          </div>
          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>
              Cancel
            </button>
            {loading ? (
              <button type="button" disabled>
                Saving...
              </button>
            ) : (
              <button type="submit">Save</button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CorsOriginModal;
